'use client'

import * as React from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { TableRow, TableCell } from '@/components/ui/table'

interface TranslationsTableSkeletonProps {
	rows?: number
}

/**
 * Skeleton for the translations table. Columns mirror the order in
 * `translations-table-columns.tsx`:
 *   select → locale → countryCode → enabled → id → actions
 */
export function TranslationsTableSkeleton({ rows = 10 }: TranslationsTableSkeletonProps) {
	return (
		<SkeletonTheme baseColor="#f8fafc" highlightColor="#f1f5f9" borderRadius="0.375rem">
			<>
				{Array.from({ length: rows }, (_, index) => (
					<TableRow key={index}>
						{/* Select Checkbox */}
						<TableCell className="w-10">
							<Skeleton height={16} width={16} />
						</TableCell>

						{/* Locale (primary) */}
						<TableCell>
							<Skeleton height={16} width={80} />
						</TableCell>

						{/* Country Code */}
						<TableCell className="w-24">
							<Skeleton height={20} width={60} />
						</TableCell>

						{/* Enabled / Status */}
						<TableCell className="w-24">
							<Skeleton height={20} width={72} />
						</TableCell>

						{/* Translation ID (copyable) */}
						<TableCell className="w-32">
							<Skeleton height={20} width={100} />
						</TableCell>

						{/* Actions */}
						<TableCell className="w-10">
							<Skeleton height={32} width={32} borderRadius="0.25rem" />
						</TableCell>
					</TableRow>
				))}
			</>
		</SkeletonTheme>
	)
}

